import createVueComponent from '../createVueComponent';

const ArrowBigUpDash = createVueComponent('ArrowBigUpDashIcon', [
  ['path', { d: 'M9 19h6', key: '456am0' }],
  ['path', { d: 'M9 15v-3H5l7-7 7 7h-4v3H9z', key: '1r2uve' }],
]);

export default ArrowBigUpDash;
